import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

const StyledErrorBanner = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-left: ${({ theme }) =>
    theme.hasStripeOnErrorBanner
      ? `4px solid ${theme.colors.highlight3}`
      : "none"};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusBanner};
  // background-color: rgba(46, 125, 50, 0.1);
  background-color: rgba(191, 23, 34, 0.1);
  white-space: pre-wrap;
  margin-bottom: 24px;

  img {
    margin-right: 8px;
  }

  ${Summary} {
    margin-bottom: 8px;
    font-weight: 600;
  }
`;

export default StyledErrorBanner;
